export default "<h1>Not Found</h1>\n\n<div class=\"content\">\n  The page you are trying to view does not exist.\n</div>\n"